import React from "react";
import { ReactSVG } from "react-svg";

const CategoryCard = ({
  cateCardtitle,
  cateCardImg,
  selectedIcon,
  onSelect,
  selected,
  isPublished = true,
}) => {
  return (
    <div
      className="relative cursor-pointer"
      onClick={isPublished ? onSelect : null}
    >
      {selected && (
        <div className="w-full h-full bg-primary rounded-2xl absolute z-[-1] top-[5px] left-[-5px]"></div>
      )}
      <div
        className={`px-14 z-20 w-full bg-secondary text-base sm:px-14 lg:px-16 2xl:px-18 lg:text-base font-ralewaySemiBold py-4 2xl:py-5 rounded-2xl shadow-custom-gray 2xl:text-lg ${
          selected ? "text-primary" : "text-customBlack"
        } ${isPublished ? "cursor-pointer" : "opacity-50 cursor-not-allowed"}`}
      >
        {cateCardtitle}
      </div>
      {isPublished ? (
        ""
      ) : (
        <div className="absolute -top-2 right-2 bg-gradient-to-r from-green-400 to-green-600 text-white text-[12px] font-semibold px-3 py-[2px] rounded-full shadow-md z-20">
          Coming Soon
        </div>
      )}
      <img
        className="absolute left-5 2xl:left-6 top-1/2 transform -translate-y-1/2 w-5 h-5  lg:h-7 lg:w-6"
        src={cateCardImg}
        alt="Usericons"
      />
      {selected && (
        <ReactSVG
          src={selectedIcon}
          className={
            "absolute right-5 2xl:right-6 top-1/2 transform -translate-y-1/2 w-5 h-5 lg:h-6 lg:w-6"
          }
        />
      )}
    </div>
  );
};

export default CategoryCard;
